import React, { useEffect, useRef, useState } from "react";
import { CONTRACT_VARIABLES } from "../variables";

// "+ Insert Variable" trigger + popover menu. Calls `onInsert(item)` when the
// user picks a variable; closes on outside click.
const VariableDropdown = ({ onInsert }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div className="contract-variable-trigger-wrap" ref={containerRef}>
      <button
        type="button"
        className="contract-variable-trigger"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        + Insert Variable
      </button>
      {open && (
        <div className="contract-variable-menu" role="menu">
          {CONTRACT_VARIABLES.map((group) => (
            <div key={group.group}>
              <div className="contract-variable-group-label">{group.group}</div>
              {group.items.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  className="contract-variable-item"
                  onClick={() => {
                    onInsert(item);
                    setOpen(false);
                  }}
                >
                  <span
                    className={
                      item.isSignature
                        ? "contract-chip contract-chip-signature"
                        : "contract-chip"
                    }
                  >
                    {item.label}
                  </span>
                </button>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VariableDropdown;
